export const landingPageFormValue={
    fName: "",
    lName: "",
    email: "",
    mobileNo: "",
    companyName: "",
    message: "",

  }